import { random } from "lodash";
import { Color } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import { tr } from "@radarly/i18n";
import { getAccessDefault } from "./access";
import { InsightPage, Row } from "./model";

const INSIGHT_PAGE_COLORS = [
  "#0887c9",
  "#be45b0",
  "#f79919",
  Color.LightSeaGreen,
  "#fa4e7c",
];

export function getRandomInsightPageColor() {
  return INSIGHT_PAGE_COLORS[random(0, INSIGHT_PAGE_COLORS.length - 1)];
}

export function getNewInsightPage(
  locale: Locale,
  author: number,
  project: number,
  workspaceId: number,
  timezone: Timezone,
  rows?: Row[]
): InsightPage {
  return {
    id: "",
    title: tr(locale, "CUSTOM_PAGE_NEW_PAGE"),
    projectId: project,
    dashboardId: workspaceId,
    aiContext: "",
    author,
    timezone,
    access: getAccessDefault(),
    rows: rows || [],
    picture: "",
    description: "",
    color: getRandomInsightPageColor(),
    filters: {
      static: [],
      dynamic: true,
    },
    periodSelector: true,
    sharedWith: [],
  };
}

export function checkInsightPageBeforeSave(page: InsightPage, locale: Locale) {
  return {
    ...page,
    title: !!page.title.trim()
      ? page.title
      : tr(locale, "CUSTOM_PAGE_UNTITLED"),
  };
}
